import { gql } from '@apollo/client'
export const queryApplicenseCount = gql`
query Query{
    getApplicenseCount
}
`
export const queryCompaniesCount = gql`
query Query{
    getCompaniesCount
}
`
export const queryDeviceCount = gql`
query Query{
    getDeviceCount
}
`
export const queryMeasureCount = gql`
query Query{
    getMeasureCount
}
`
export const queryApplicenseCountByDate = gql`
query Query($startDate: Date!, $endDate: Date!) {
    getApplicenseCountByDate(startDate: $startDate, endDate: $endDate) {
      year
      month
      count
    }
  }
`
export const queryCompanyCountByDateStartDate2 = gql`
query Query($startDate: Date!, $endDate: Date!) {
    getCompanyCountByDate(startDate: $startDate, endDate: $endDate) {
      year  
      month
      count
    }
  }
`
export const queryDeviceTypeList = gql`
query Query{
    getDeviceTypeList
}
`
export const queryDeviceActiveTrendByMonths = gql`
query Query($start: String!, $end: String!,$deviceModel: String) {
    deviceActiveTrendByMonths(start: $start, end: $end, deviceModel: $deviceModel) {
      year
      month
      count
    }
  }
`
export const queryMeasureTypeList = gql`
query Query{
    getMeasureTypeList
}
`
export const queryMeasureTrendByMonths = gql`
query Query($start: String!, $end: String!,$deviceModel: String) {
  measureTrendByMonths(start: $start, end: $end, deviceModel: $deviceModel) {
      year
      month
      count
  }
}
`